/**
 * 全局配置文件
 */
export default {
  app_version: "1.0.3",
  title: "realbow",
  logo: "R",
  key: 'saber',//配置主键,目前用于存储
  indexTitle: 'REALBOW',
  clientId: 'saber', // 客户端id
  clientSecret: 'saber_secret', // 客户端密钥
  tenantMode: true, // 是否开启租户模式
  tenantId: "000000", // 管理组租户编号
  captchaMode: true, // 是否开启验证码模式
  lockPage: '/lock',
  tokenTime: 3000,
  tokenHeader: 'Blade-Auth',
  //http的status默认放行列表
  statusWhiteList: [],
  //配置首页不可关闭
  // isFirstPage: false,
  // fistPage: {
  //   label: "控制台",
  //   // value: "/wel/index",
  //   value: "/wel/dashboard",
  //   params: {},
  //   query: {},
  //   meta: {
  //     i18n: 'dashboard'
  //   },
  //   group: [],
  //   close: false
  // },
  //配置菜单的属性
  // menu: {
  //   iconDefault: 'iconfont icon-caidan',
  //   props: {
  //     label: 'name',
  //     path: 'path',
  //     icon: 'source',
  //     children: 'children'
  //   }
  // },
  // 第三方系统授权地址
  // authUrl: 'http://localhost/blade-auth/oauth/render',
  // authUrl: 'http://192.168.80.184:8100/blade-auth/oauth/render',
  authUrl: 'http://192.168.172.23:10000/api/blade-auth/oauth/render',
  // 流程设计器地址
  // flowDesignUrl: 'http://localhost:9999',
  flowDesignUrl: 'http://192.168.172.23:9999',
  // 报表设计器地址(cloud端口为8108,boot端口为80)
  // reportUrl: 'http://localhost:8108/ureport',
  reportUrl: 'http://127.0.0.1:8108/ureport',
  // reportUrl: 'http://192.168.172.23:8108/ureport',
};



// WEBPACK FOOTER //
// ./src/config/website.js